import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { connect } from 'formik';
import { palette } from '../../constants/styles';
import InputText from './InputText';
import { AsSelector } from '../theme/InputText';
import Icon from './Icon';

const inputStyles = {
  margin: '0',
  maxWidth: '100px',
  caretColor: 'transparent',
  transform: 'scale(0)',
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 2px 0px 2px 10px;
  border-radius: 8px;
  margin-top: -3px;
  background: ${palette.sweetGray};
  cursor: pointer;  
  position: relative;
`;

const SelectValues = styled.div`
  position: fixed;
  display: none;
  cursor: pointer;

  font-size: 1.2rem;
  font-weight: 500;

  width: 100%;

  overflow-y: scroll;
  z-index: 1;

  bottom: 0;
  left: 0;
  height: fit-content;
  max-height: 50vh;

  ${({ show }) => show && css`
    display: block;
  `}
`;

const SelectOption = styled.div`
  cursor: pointer;
  padding: 10px;
  box-sizing: border-box;

  font-size: 1.2rem;
  font-weight: 500;

  color: white;
  background: ${palette.secondaryColor};
  
  &:hover {
    color: ${palette.secondaryActiveText};
    background: ${palette.secondaryActiveBg};
  }

  cursor: pointer;
`;

const Label = styled.label`
  cursor: pointer;
  width: 80%;
  font-size: 1rem;
  font-weight: 500;
  position: relative;
  width: fit-content;
  height: fit-content;
  top: 0;
  left: 0;
  z-index: 1;
  color: ${palette.textColor};
`;

const Placeholder = styled(Label)`
  color: ${palette.sublimeGray};
`;

export const StyledItemIcon = (open) => {
  const degrees = open ? '0' : '45';
  return (
    {
      minWidth: '40px',
      transform: `rotate(${degrees}deg)`,
      transition: 'all .1s cubic-bezier(.63,.64,.3,1)',
    }
  );
};

class Select extends Component {
  state = { open: false, itemSelected: '' };

  setItem = (name, { label, value }) => {
    const { formik, goToNextInput, id } = this.props;
    formik.setFieldValue(name, value);
    this.setState({ itemSelected: label });
    goToNextInput(id);
  }

  openMenu = () => this.setState({ open: true });

  closeMenu = () => this.setState({ open: false });

  // eslint-disable-next-line react/destructuring-assignment, react/no-access-state-in-setstate
  toggleMenu = () => this.setState({ open: !this.state.open });

  handleOnFocus = (ev) => {
    const { onFocus } = this.props;
    onFocus(ev);
  }

  render() {
    const {
      id,
      className,
      autoFocus,
      name,
      onChange,
      onBlur,
      value,
      placeholder,
      options,
      onOptionSelected,
      style,
    } = this.props;
    const { itemSelected, open } = this.state;
    return (
      <Wrapper onClick={this.toggleMenu} style={style}>
        {itemSelected ? <Label>{itemSelected}</Label> : <Placeholder>{placeholder}</Placeholder>}
        <Icon icon="cross2" color="rgba(2, 39, 89, 0.4)" size={20} style={StyledItemIcon(open)} />
        <InputText
          theme={AsSelector}
          id={id}
          className={className}
          name={name}
          value={value}
          onChange={onChange}
          onFocus={this.handleOnFocus}
          onBlur={onBlur}
          style={inputStyles}
          placeholder={placeholder}
          autoFocus={autoFocus}
          autoComplete="off"
          dissapear
          readOnly
        />
        <SelectValues show={open}>
          {options.map(answer => (
            <SelectOption
              key={id + answer.value}
              onClick={() => {
                onOptionSelected(answer);
                this.setItem(name, answer);
                this.closeMenu();
              }}
            >
              {answer.label}
            </SelectOption>
          ))}
        </SelectValues>
      </Wrapper>
    );
  }
}

Select.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  autoFocus: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  options: PropTypes.array,
  onOptionSelected: PropTypes.func,
  formik: PropTypes.object,
  goToNextInput: PropTypes.func,
  style: PropTypes.object,
};

Select.defaultProps = {
  id: '',
  className: '',
  autoFocus: '',
  name: '',
  onChange: () => {},
  onFocus: () => {},
  onBlur: () => {},
  value: '',
  placeholder: '',
  options: [],
  onOptionSelected: () => {},
  formik: {},
  goToNextInput: () => {},
  style: {},
};

export default connect(Select);
